import { useIntl } from '@capsicum/common';

export const useTopUpDrawer = () => {
	const { $t } = useIntl();

	const texts = {
		amountNeeded: $t('marketplace.tokenBalance.amountNeeded'),
		buttonLabel: $t('rewards.auctions.topUpNow'),
		description: $t('rewards.auctions.notEnoughFunds'),
		title: $t('rewards.auctions.InsufficientCHZ'),
		yourBalance: $t('marketplace.tokenBalance.yourBalance')
	};

	return {
		texts
	};
};
